import { useCallback } from "react";
import { getHost } from "./getHost";

// Asks the host to run reCAPTCHA v3 on the embed's behalf and return a
// token. Keeps the Google reCAPTCHA site key + script load registered
// against the presenter's domain — the embed doesn't need its own key.
//
// Returns `null` when:
//   - running standalone (no host)
//   - the host doesn't expose `executeRecaptcha`
//   - the host's loader failed
// Callers should fall back to `bypassRecaptcha: true` in the request
// body so the upstream API can decide whether to accept it.

export type RecaptchaFn = (action: string) => Promise<string | null>;

export function useHostRecaptcha(): RecaptchaFn {
  return useCallback(async (action: string) => {
    const host = getHost();
    if (!host?.executeRecaptcha) return null;
    try {
      return await host.executeRecaptcha(action);
    } catch {
      return null;
    }
  }, []);
}
